// extracted by mini-css-extract-plugin
export default {"item":"ServiceItem_item__ktDlO","icon":"ServiceItem_icon__bdMaM","title":"ServiceItem_title__NIHi-","description":"ServiceItem_description__p1uHp"};